import { ReturnItem, ReturnOrderLine } from 'returnCenter-api';
import { HandleReturnItemChange } from 'components/Orders/Order';
import SwitchToggle from 'components/ui/Switch';
import Flex from 'components/ui/Flex';
import { CellInputRefs } from 'hooks/useKeyboardNavigation';

type ReturnToStockCellProps = {
    item: ReturnItem;
    itemId?: number | string;
    handleReturnItemChange: HandleReturnItemChange;
    orderline?: ReturnOrderLine;
    compact?: boolean;
    disabled?: boolean;
    rowIndex?: string | number;
    colIndex?: string | number;
    cellInputRefs?: CellInputRefs;
    handleArrowKeyDown: (e: any, orderId: any, rowIndex: any, colIndex: any) => void;
    cellRefPrefix?: string;
};

const ReturnToStockCell = ({
    itemId,
    compact,
    item,
    handleReturnItemChange,
    orderline,
    rowIndex,
    colIndex,
    cellInputRefs,
    handleArrowKeyDown,
    cellRefPrefix = '',
    disabled = false,
}: ReturnToStockCellProps) => {
    return (
        <Flex className="switch-wrapper" column gap="0.5rem" align="start" justify={compact ? 'start' : 'center'}>
            <SwitchToggle
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        if (disabled) return;
                        handleReturnItemChange(
                            orderline?.orderNumber ?? '',
                            orderline?.sku ?? '',
                            orderline?.orderLineNumber ?? '',
                            itemId ?? -1,
                            'returnToStock',
                            !(item.returnToStock ?? true),
                        );
                        return;
                    }
                    handleArrowKeyDown(e, itemId, rowIndex, colIndex);
                }}
                ref={(el) => {
                    const key = `${cellRefPrefix}${rowIndex}-${colIndex}`;
                    if (cellInputRefs) cellInputRefs.current[key] = el;
                }}
                disabled={disabled}
                data-returnToStock
                data-row={rowIndex}
                data-row-cell={colIndex}
                data-item-id={itemId}
                key={itemId}
                checked={item.returnToStock ?? true}
                onHandleToggle={(checked) =>
                    handleReturnItemChange(
                        orderline?.orderNumber ?? '',
                        orderline?.sku ?? '',
                        orderline?.orderLineNumber ?? '',
                        itemId ?? -1,
                        'returnToStock',
                        checked,
                    )
                }
                size="medium"
                tabIndex={0}
            />
        </Flex>
    );
};

export default ReturnToStockCell;
